import { Check, MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

const WHATSAPP_URL = "https://wa.me/918882183014?text=Hi%2C%20I%20want%20to%20book%20a%20water%20tank%20cleaning%20service%20in%20Gurugram";

const plans = [
  {
    title: "Residential",
    subtitle: "Homes & Apartments",
    price: "999",
    features: [
      "Up to 1,000 litre tank",
      "High-pressure jet cleaning",
      "Anti-bacterial treatment",
      "Completion in 2-3 hours",
      "30-day hygiene guarantee",
    ],
  },
  {
    title: "Premium",
    subtitle: "Large Homes & RWAs",
    price: "1,999",
    popular: true,
    features: [
      "Up to 5,000 litre tank",
      "High-pressure jet cleaning",
      "UV disinfection included",
      "Same day service",
      "60-day hygiene guarantee",
      "Water quality testing",
    ],
  },
  {
    title: "Commercial",
    subtitle: "Hotels & Complexes",
    price: "4,999",
    features: [
      "Up to 25,000 litre tank",
      "Industrial-grade cleaning",
      "Full disinfection suite",
      "Compliance certificate",
      "90-day hygiene guarantee",
      "Quarterly maintenance plan",
    ],
  },
];

export default function PricingSection() {
  return (
    <section id="pricing" data-testid="pricing-section" className="py-20 md:py-24 bg-surface">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-16">
          <p className="text-sky font-medium text-sm uppercase tracking-[0.2em] mb-3">
            Pricing
          </p>
          <h2 className="font-heading font-bold text-3xl sm:text-4xl tracking-tight text-navy">
            Transparent Pricing
          </h2>
          <p className="text-slate-600 text-base mt-3 max-w-lg mx-auto">
            Starting prices. Final quote depends on tank size, condition, and location.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {plans.map((plan, i) => (
            <div
              key={plan.title}
              data-testid={`pricing-card-${i}`}
              className={`relative bg-white border rounded-xl p-8 transition-all duration-300 hover:shadow-lg hover:-translate-y-1 ${
                plan.popular
                  ? "border-sky shadow-md ring-2 ring-sky/20"
                  : "border-slate-200 hover:border-sky/50"
              }`}
            >
              {plan.popular && (
                <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-sky text-white text-xs font-bold uppercase tracking-wider px-4 py-1 rounded-full">
                  Most Popular
                </span>
              )}

              <h3 className="font-heading font-bold text-xl text-navy">{plan.title}</h3>
              <p className="text-slate-500 text-sm mb-5">{plan.subtitle}</p>

              <div className="flex items-baseline gap-1 mb-6">
                <span className="text-sm text-slate-500">Starting at</span>
                <span className="font-heading font-extrabold text-4xl text-navy ml-1">
                  &#8377;{plan.price}
                </span>
              </div>

              <ul className="space-y-3 mb-8">
                {plan.features.map((f) => (
                  <li key={f} className="flex items-start gap-3 text-sm text-slate-700">
                    <Check className="w-4 h-4 text-sky mt-0.5 flex-shrink-0" />
                    {f}
                  </li>
                ))}
              </ul>

              <Button
                asChild
                data-testid={`pricing-cta-${i}`}
                className={`w-full rounded-full font-semibold transition-all duration-300 ${
                  plan.popular
                    ? "bg-sky hover:bg-sky/90 text-white"
                    : "bg-navy hover:bg-navy-light text-white"
                }`}
              >
                <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer">
                  <MessageCircle className="w-4 h-4 mr-2" />
                  Get Custom Quote
                </a>
              </Button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
